export default "__VITE_ASSET__CuO4rcJe__"